export function removeCookie(name: string, domain: string) {
  const cookieStr = `${name}=; domain=${domain}; path=/; max-age=-1;`;
  document.cookie = cookieStr;
}

export function getDocumentCookie() {
  return document.cookie;
}
